import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';


// import * as _ from 'lodash';
// Local Deps
// import { columns } from './gridConfig';
// import { LinkContainer } from 'react-router-bootstrap';
import { Popconfirm, Tooltip, message } from 'antd';
// Local Deps
// import { editInventoryManagementRoute } from '../../../config/navigation/routes';
import getCodeDefinitions from '../../../graphql/codeDefinitions';
import { deleteItem, getInventoryManagementList } from '../../../graphql/item';
import EditInventoryManagement from '../../Modals/EditInventoryManagement';
import { LoadingTable } from '../../Loading';

import trashCan from '../../../images/trashcan.svg';
import edit from '../../../images/edit.svg';
import './InventoryManagementGrid.scss';

export default class InventoryGrid extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      jwtToken: PropTypes.string.isRequired,
      expiration: PropTypes.number.isRequired,
      organizationId: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
      cageCode: PropTypes.string.isRequired,
      email: PropTypes.string,
    }).isRequired,
    inventoryFilter: PropTypes.object,
  };

  static defaultProps = {
    inventoryFilter: undefined,
  };

  static initialState = {
    inventoryList: [],
    hits: 0,
    ui: [],
    qup: [],
    page: 0,
    pages: 0,
    errors: [],
    isLoading: true,
    inventoryFilter: undefined,
    showTable: true,
    pageSize: 20,
    sorted: [
      { id: 'partNum', desc: false }
    ],
    selectedItemId: undefined,
    showEditModal: false,
  };
  state = InventoryGrid.initialState;

  componentDidMount() {
    this.retrieveCodeDefinitions("UI", "ui");
    this.retrieveCodeDefinitions("QUP", "qup");
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.inventoryFilter !== prevState.inventoryFilter) {
      return { inventoryFilter: nextProps.inventoryFilter };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.inventoryFilter !== this.state.inventoryFilter) {
      this.remountTable()
    }
  }
  remountTable() {
    this.setState({ showTable: false })
    setTimeout(() => this.setState({ showTable: true }), 5)
  }

  retrieveInventoryByCage = async (page, pageSize, sorted) => {
    this.setState({ isLoading: true });
    const { cageCode } = this.props.auth;
    const filter = this.props.inventoryFilter;
    const offset = page * pageSize;
    let inventoryList = [];
    let hits = 0;
    try {
      const { inventorySearch } = await getInventoryManagementList(cageCode, offset, pageSize, sorted, filter);
      inventoryList = inventorySearch.itemList || [];
      hits = inventorySearch.hits || 0;
    } catch (error) {
      message.error("Failed to retrieve Inventory List from Database.");
    }

    if (inventoryList.length > 0) {
      for (let i = 0; i < inventoryList.length; i += 1) {
        console.log(inventoryList[i].visibility)
        inventoryList[i].visibility = inventoryList[i].visibility === true ? "Public" : "Gov't Only";
        console.log(inventoryList[i].visibility)
        inventoryList[i].qup = [inventoryList[i].qup, this.state.qup[inventoryList[i].qup]];
        inventoryList[i].ui = [inventoryList[i].ui, this.state.ui[inventoryList[i].ui.toUpperCase()]];
      }
    }
    const pages = Math.ceil(hits / pageSize)
    this.setState({ inventoryList, hits, pages, isLoading: false });
  };

  retrieveCodeDefinitions = async (codeName, codeList) => {
    const res = await getCodeDefinitions(codeName);
    console.log(res);
    // const result = res.reduce((r, { code, definition }) => (r[code] = definition, r), {})
    const result = res.reduce((c, { codeValue, codeDefinition }) => ({
      ...c,
      [codeValue]: codeDefinition
    }), {});
    this.setState({ [codeList]: result });
  }

  onPageChange = page => {
    this.setState({ page });
  };

  onPageSizeChange = pageSize => {
    this.setState({ pageSize });
  };

  onSortedChange = sorted => {
    this.setState({ sorted });
  };

  handleDelete = async id => {
    const { email } = this.props.auth;

    try {
      const {
        deleteItem: { status },
      } = await deleteItem(id, email, "I");
      if (status === 'success') {
        message.success('Inventory item Successfully Deleted!');
        this.reloadItems();
      }
    } catch (error) {
      message.error('Could not Delete Inventory Item');
    }
  };

  closeEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedItemId: undefined,
    });
  }
  reloadItems = async () => {
    await this.retrieveInventoryByCage(this.state.page, this.state.pageSize, this.state.sorted);
  }

  openEditModal = (itemId) => {
    this.setState({
      showEditModal: true,
      selectedItemId: itemId,
    });
  }
  render() {
    const { inventoryList, hits, pages, pageSize, sorted, isLoading } = this.state;

    const columns = [
      {
        Header: 'Part No',
        accessor: 'partNum',
        minWidth: 120,
      },
      {
        Header: 'NSN',
        accessor: 'niin',
        minWidth: 120,
      },

      {
        Header: 'Description',
        accessor: 'description',
        minWidth: 120,
      },
      {
        Header: 'Price',
        accessor: 'price',

        Cell: cellProps => (
          cellProps.value.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          })
        ),
        minWidth: 100,
      },
      {
        Header: 'UI',
        accessor: 'ui',
        Cell: cellProps => (
          <div>
            <Tooltip title={cellProps.value[1]}>{cellProps.value[0]}</Tooltip>
          </div>
        ),
        minWidth: 65,
      },
      {
        Header: 'QUP',
        accessor: 'qup',
        Cell: cellProps => (
          <div>
            <Tooltip title={cellProps.value[1]}>{cellProps.value[0]}</Tooltip>
          </div>
        ),
        minWidth: 120,
      },
      {
        Header: 'SOH',
        accessor: 'soh',
        minWidth: 120,
      },
      {
        Header: 'Visibility',
        accessor: 'visibility',
        minWidth: 120,
      },
      {
        Header: 'Action',
        accessor: 'action',
        minWidth: 80,
        sortable: false,
        Cell: cellProps => (
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-around',
            }}
          >
            <button
              onClick={() => {
                this.openEditModal(cellProps.original.id);
              }}
              className="tooling-action"
            >
              <img src={edit} alt="Edit" />
            </button>
            <Popconfirm
              title="Are you sure you want to delete this item? This action cannot be undone!"
              onConfirm={() => this.handleDelete(cellProps.original.id)}
              okText="Yes"
              cancelText="No"
            >
              <button className="tooling-action">
                <img src={trashCan} alt="delete" />
              </button>
            </Popconfirm>
          </div>
        ),
      },
    ];

    return (
      <Fragment>
        <div className="nf-tooling-mgmt-grid">
          {this.state.showTable &&
            <Fragment>
              <div>
                <p style={{ fontWeight: '600' }}>Found {hits} Results</p>
              </div>
              <ReactTable
                data={inventoryList}
                pages={pages}
                columns={columns}
                noDataText='No inventory found'
                defaultPageSize={pageSize}
                minRows={3}
                showPagination
                showPaginationBottom
                showPageJump
                pageSizeOptions={[20, 50, 100, 250, 500]}
                manual // this indicates that server side pagination has been enabled 
                onPageChange={this.onPageChange}
                onPageSizeChange={this.onPageSizeChange}
                onSortedChange={this.onSortedChange}
                // filterable
                defaultSorted={sorted}
                // multiSort={false}
                loading={isLoading}
                LoadingComponent={LoadingTable}
                onFetchData={(state) => {
                  this.retrieveInventoryByCage(state.page, state.pageSize, state.sorted)
                }}
              />
            </Fragment>
          }
        </div>
        {this.state.showEditModal && this.state.selectedItemId &&
          <EditInventoryManagement
            selectedItemId={this.state.selectedItemId}
            showEditModal={this.state.showEditModal}
            auth={this.props.auth}
            closeEditModal={this.closeEditModal}
            reloadItems={this.reloadItems}
          />
        }
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/InventoryManagementGrid/InventoryManagementGrid.jsx